import React from 'react';

import Icon from 'common/components/Icon';
import Typography from 'common/components/Typography';
import styles from './SuccessStep.module.css';

const SuccessStep = () => (
  <div className={styles.body} data-test="withdrawal-success">
    <div className={styles.infoHeader}>
      <Icon.GiftDuotone
        className={styles.icon}
        description="Withdrawal requested"
        size="medium"
      />
      <Typography
        tag="span"
        size="base"
        weight="semiBold"
        color="color-neutral-900"
      >
        Withdrawal requested
      </Typography>
    </div>
    <Typography tag="p" size="xs" color="color-neutral-500">
      Your withdrawal request was submitted and your wallet will be credited
      soon. You can check on the status of the request in the history tab.
    </Typography>
  </div>
);

export default SuccessStep;
